var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"navigation-header mt-2"},[_c('span',[_vm._v(_vm._s(_vm.$t(("menu." + (_vm.item.header)))))])])}
var staticRenderFns = []

export { render, staticRenderFns }